import { DomainException } from './domain-exception';

export class LimitExceededException extends DomainException {
  constructor(message: string) {
    super(message);
  }
}
